module.exports = __webpack_public_path__ + "fonts/Gilroy-HeavyItalic.574db652.ttf";